import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

// The same bolt as flash-off, so toggling only adds or removes the slash.
export const FlashOn = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="flash on icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path className={pathClass} d="M16 1L3.5 15H9.5L8 23L20.5 9H14.5L16 1Z" />
  </svg>
)
